import React from 'react';

import { TransparentContainer } from 'components/common/TransparentContainer';
import { Row, Col, Container } from 'reactstrap';
import { FlexContainer } from '../FlexContainer';
import { Section } from './atoms/Section';

export const ContentSection: React.FC = ({ children }) => {
    return (
        <Section>
            <FlexContainer>
                <TransparentContainer>
                    <Container>
                        <Row>
                            <Col lg={{ size: 8, offset: 2 }}>{children}</Col>
                        </Row>
                    </Container>
                </TransparentContainer>
            </FlexContainer>
        </Section>
    );
};
